export const ENABLE_KRASAVA_LANDING = 'ENABLE_KRASAVA_LANDING';

export const DEFAULT_KRASAVA_THEME = {
    bg: '#080908',
    cardBg: '#141614',
    text: '#ffffff',
    muted: '#a3a3a3',
    accent: '#ffdc00',
    btnBg: '#ffdc00',
    btnText: '#080908',
};

const EN = {
    navMembership: 'Membership',
    navCommunity: 'Community',
    navSupporters: 'Supporters',
    navEvents: 'Events',
    navPeople: 'People',
    navPartners: 'Partners',
    navLive: 'Conversation',
    navShop: 'Shop',
    navPaths: 'Ways',
    login: 'Log in',
    become: 'Become a member',
    heroEyebrow: 'Krasava · Worldwide',
    heroIntro: 'Find your people. Build connections. Create opportunities. Wherever life takes you.',
    heroLede: 'Find your people. Build connections. Create opportunities. Wherever life takes you.',
    heroTitleLead: 'Krasava.',
    heroTitleAccent: 'Freedom.',
    heroTitleEnd: 'Family.',
    heroLine1: 'Krasava.',
    heroLine2: 'Freedom.',
    heroPrimary: 'Become a member',
    heroSecondary: 'Learn more',
    cardName: 'Alexander Morozov',
    cardName2: 'Alexander Morozov',
    cardName3: 'Alexander Morozov',
    cardKicker: 'Krasava community',
    cardRole: 'Founder, Morozov Studio',
    cardTagline: 'Creative director & brand builder',
    cardBadge1: 'Supports Krasava',
    cardBadge2: 'Active member',
    cardBadge3: 'Entrepreneur',
    cardNumber: 'Krasava member №0001',
    cardCity: 'Limassol / Cyprus',
    cardSince: 'Since 2026',
    cardBack: 'Your club. Your people. Everywhere.',
    benefitsEyebrow: 'Membership, expanded',
    benefitsTitleLead: 'More Than a Club.',
    benefitsTitleAccent: 'Your World.',
    benefitsLine1: 'More Than a Club.',
    benefitsLine2: 'Your World.',
    benefitsIntro: 'A community that brings Krasava closer — wherever in the world you are.',
    benefits: [
        { title: 'Events & experiences', text: 'Join matches, meetups, watch parties and club activities.' },
        { title: 'Places & benefits', text: 'Discover partner venues and special member offers.' },
        { title: 'Krasava everywhere', text: 'Your membership stays with you across cities and countries.' },
        { title: 'Exclusive access', text: 'Get priority access to tickets, new drops, limited merch and members-only opportunities.' },
        { title: 'People & community', text: 'Meet members and connect with local Krasava crews.' },
    ],
    globeEyebrow: 'Community without borders',
    globeTitle: 'Our global community',
    globeTitleLead: 'Our Global',
    globeTitleAccent: 'Community.',
    globeLede: 'Find Krasava people, events and connections wherever you are.',
    membersLabel: 'members',
    countriesLabel: 'countries',
    partnersLabel: 'partners',
    citiesLabel: 'cities',
    supportersEyebrow: 'Part of Krasava',
    supportersTitleLead: 'Star',
    supportersTitleAccent: 'Supporters.',
    supportersIntro: 'Meet some of the people who support Krasava and are part of the community.',
    supporters: [
        { name: 'Yury Dud', caption: 'Prototype portrait', credit: 'UNIVER TV · CC BY 3.0' },
        { name: 'Elizaveta Osetinskaya', caption: 'Prototype portrait', credit: 'Birulik · CC BY-SA 4.0' },
    ],
    aroundEyebrow: 'Around you',
    aroundTitleLead: 'Krasava',
    aroundTitleAccent: 'Around You.',
    aroundLine2: 'Around You.',
    aroundIntro: 'Meet people. Make connections. Experience Krasava wherever you are.',
    aroundCity: 'Limassol / Cyprus',
    aroundMore: 'Explore Events & Community',
    aroundCta: 'Explore Events & Community',
    around: [
        { badge: 'Local community', meta: '05 Sep · 09:00 · Molos Promenade', title: 'Krasava beach run', text: '5K by the sea with the Krasava community. Run, meet, stay for coffee.', cta: 'Join the run' },
        { badge: 'Event', meta: '10 Oct · 19:00 · Punin Wine', title: 'Krasava watch party', text: 'Krasava vs APOEL. Watch the game with the local Krasava crew.', cta: 'Get tickets' },
        { badge: 'Partner news', meta: 'Old Town · Bar · Limassol', title: 'Mixology bar is in', text: 'New partner: a new Krasava spot in the city. Members get 10% off.', cta: 'Discover the place' },
        { badge: 'Meetup', meta: '11 Sep · 18:00 · Zante Venue', title: 'Cyprus crew grows', text: 'More Krasava people. More connections. One growing community. Come meet your crew.', cta: 'Join the meetup' },
    ],
    peopleEyebrow: 'Made of moments',
    peopleTitle: 'Life Is Better',
    peopleTitleRest: 'With Your',
    peopleTitleAccent: 'People.',
    peopleLine1: 'Life Is Better',
    peopleText: 'Friends, connections, opportunities — and people who make anywhere feel more like home.',
    peopleLede: 'Friends, connections, opportunities — and people who make anywhere feel more like home.',
    peopleCta: 'Find Your People',
    peopleButton: 'Find Your People',
    quotes: [
        'Coffee after the game?',
        'Best place to watch football in Limassol?',
        "Who's joining the beach run on Saturday?",
        'Need two more for our 5-a-side team',
    ],
    liveEyebrow: 'Always connected',
    liveTitleLead: 'Stay in the',
    liveTitleAccent: 'Conversation.',
    liveText: 'Make plans. Share ideas. Find opportunities. Stay connected with your people wherever you are.',
    chats: [
        { author: 'Alex · Limassol', text: 'Anyone watching the game tonight? ⚽', meta: '19:42' },
        { author: 'Misha', text: 'I’m in. Same place as last time?', meta: '19:44 · ♥ 4' },
        { author: 'Anna · Barcelona', text: 'Any Krasava people around this weekend?', meta: '11:08' },
        { author: 'Dmitry', text: 'Yep 👋 Let’s grab a drink.', meta: '11:12 · ♥ 6' },
    ],
    partnersEyebrow: 'Backing Krasava',
    partnersTitleLead: 'Sponsors of',
    partnersTitleMid: 'the Season.',
    partnersLine1: 'Sponsors of',
    partnersLine2: 'the Season.',
    partnersTitleEnd: '',
    partnersIntro: 'Meet the brands supporting Krasava this season.',
    partners: [
        { id: 'mixology', brand: 'Punin Group', title: 'Mixology Bar', meta: 'Hospitality · Limassol' },
        { id: 'zante', brand: 'Zante', title: 'Seaside Club', meta: 'Venue · Cyprus' },
        { id: 'punin', brand: 'Punin Wine', title: 'Punin Wine', meta: 'Wine · Cyprus' },
    ],
    shopTitle: 'Be first',
    shopText: "Members get priority access to what's coming next.",
    shopTags: ['Merch', 'Tickets', 'Events', 'New drops', 'Exclusives'],
    shopCta: 'Go to the shop',
    finalEyebrow: 'Krasava membership',
    finalTitleLead: 'Become',
    finalTitleAccent: 'Krasava.',
    finalText: 'Your club. Your people. Your world.',
    finalPrimary: 'Join Krasava',
    finalSecondary: 'Already a member? Log in',
    pathsEyebrow: 'Ways to take part',
    pathsLine1: 'Choose your way',
    pathsLine2: 'to join Krasava',
    pathsIntro: 'Join the community, support the club, grow your business, or take part in the future of Krasava.',
    paths: [
        {
            title: 'Participant',
            text: 'Become part of Krasava. Meet people, join events, and find new opportunities.',
            points: ['International community', 'Events and conversation', 'New connections'],
            cta: 'Join',
        },
        {
            title: 'Donor',
            text: 'Support the club. Your contributions let the club grow and take on new projects.',
            points: ['Direct support for the club', 'Any amount', 'A stake in the future of Krasava'],
            cta: 'Support',
        },
        {
            title: 'Your business on the map',
            text: 'Tell the Krasava community about your business and find clients, partners, and new contacts on the map.',
            points: ['A place on the map', 'New clients and partners', 'Visibility among members'],
            cta: 'Present your business',
        },
        {
            title: 'Investor',
            text: 'Invest directly in Krasava. Discuss the terms with the club team.',
            points: ['A part in growing the project', 'Individual terms', 'Direct contact with the team'],
            cta: 'Discuss investment',
        },
    ],
};

const PARTNER_IDS = ['mixology', 'zante', 'punin'];
const blanks = (length) => Array.from({ length }, () => '');

const DEFAULT_CONFIG = {
    theme: DEFAULT_KRASAVA_THEME,
    logo: '',
    qr: '',
    showBall: true,
    eventCount: 10,
    sections: {
        header: true,
        hero: true,
        paths: true,
        club: true,
        globe: true,
        supporters: true,
        around: true,
        people: true,
        partners: true,
        live: true,
        shop: true,
        join: true,
    },
    facts: { members: '1,427', countries: '10', partners: '94', cities: '23' },
    links: { aroundMore: '/events', people: '/registration', shop: '', around: blanks(EN.around.length), paths: blanks(EN.paths.length) },
    images: {
        card: '',
        cardPortrait: '',
        cardShots: blanks(3),
        cardFronts: blanks(3),
        cardBacks: blanks(3),
        ball: '',
        map: '',
        shop: '',
        members: '',
        benefits: blanks(EN.benefits.length),
        around: blanks(EN.around.length),
        people: blanks(6),
        partners: blanks(EN.partners.length),
        supporters: blanks(EN.supporters.length),
        live: blanks(2),
    },
    copy: {
        EN,
        RU: {
            navPaths: 'Участие',
            cardName: 'Александр Морозов',
            cardName2: 'Александр Морозов',
            cardName3: 'Александр Морозов',
            cardKicker: 'Сообщество Krasava',
            cardRole: 'Основатель, Morozov Studio',
            cardTagline: 'Креативный директор и бренд-билдер',
            cardBadge1: 'Поддерживает Krasava',
            cardBadge2: 'Активный участник',
            cardBadge3: 'Предприниматель',
            cardNumber: 'Участник Krasava №0001',
            cardCity: 'Лимассол / Кипр',
            cardSince: 'С 2026',
            pathsEyebrow: 'Способы участия',
            pathsLine1: 'Выбери свой способ',
            pathsLine2: 'стать частью Krasava',
            pathsIntro: 'Присоединяйся к сообществу, поддерживай клуб, развивай свой бизнес или участвуй в будущем Krasava.',
            paths: [
                {
                    title: 'Участник',
                    text: 'Стань частью Krasava. Знакомься с людьми, участвуй в событиях и находи новые возможности.',
                    points: ['Международное сообщество', 'События и общение', 'Новые знакомства'],
                    cta: 'Присоединиться',
                },
                {
                    title: 'Донор',
                    text: 'Поддержи клуб. Твои взносы позволяют клубу развиваться и реализовывать новые проекты.',
                    points: ['Прямая поддержка клуба', 'Любая сумма', 'Вклад в будущее Krasava'],
                    cta: 'Поддержать',
                },
                {
                    title: 'Твой бизнес на карте',
                    text: 'Расскажи о своём бизнесе сообществу Krasava: найди клиентов, партнёров и новые деловые контакты на карте.',
                    points: ['Размещение на карте', 'Новые клиенты и партнёры', 'Видимость среди участников'],
                    cta: 'Представить бизнес',
                },
                {
                    title: 'Инвестор',
                    text: 'Напрямую инвестируй в развитие Krasava. Обсуди условия напрямую с командой клуба.',
                    points: ['Участие в развитии проекта', 'Индивидуальные условия', 'Прямой контакт с командой'],
                    cta: 'Обсудить инвестиции',
                },
            ],
        },
    },
};

const THEME_VARS = [
    ['bg', '--krasava-bg'],
    ['cardBg', '--krasava-card-bg'],
    ['text', '--krasava-text'],
    ['muted', '--krasava-muted'],
    ['accent', '--krasava-accent'],
    ['btnBg', '--krasava-btn-bg'],
    ['btnText', '--krasava-btn-text'],
];

const extractOptionType = (opt) => opt?.optionType || opt?.type || '';
const extractOptionValue = (opt) => (opt?.optionValue ?? opt?.value ?? '').trim();

function merge(base, override) {
    if (Array.isArray(override)) return override;
    if (override && typeof override === 'object' && base && typeof base === 'object' && !Array.isArray(base)) {
        const result = { ...base };
        Object.keys(override).forEach((key) => {
            result[key] = merge(base[key], override[key]);
        });
        return result;
    }
    return override === undefined ? base : override;
}

function prefer(base, override) {
    if (Array.isArray(base)) {
        return base.map((item, index) => prefer(item, Array.isArray(override) ? override[index] : undefined));
    }
    if (base && typeof base === 'object') {
        const result = {};
        Object.keys(base).forEach((key) => {
            result[key] = prefer(base[key], override && typeof override === 'object' ? override[key] : undefined);
        });
        return result;
    }
    return typeof override === 'string' && override.trim() ? override : base;
}

const LEGACY_CARD_NAMES = {
    EN: 'Your name here',
    RU: 'Ваше имя здесь',
};

const CARD_NAME_KEYS = ['cardName', 'cardName2', 'cardName3'];

function prepareCardNames(raw) {
    if (!raw || typeof raw !== 'object' || !raw.copy || typeof raw.copy !== 'object') return raw;
    const copy = { ...raw.copy };
    Object.entries(LEGACY_CARD_NAMES).forEach(([lang, legacy]) => {
        const block = copy[lang];
        if (!block || typeof block !== 'object' || Array.isArray(block)) return;
        const next = { ...block };
        const fallback = DEFAULT_CONFIG.copy[lang].cardName;
        CARD_NAME_KEYS.forEach((key) => {
            if (next[key] === legacy) next[key] = fallback;
        });
        const name = typeof next.cardName === 'string' ? next.cardName.trim() : '';
        if (name) {
            if (next.cardName2 === undefined) next.cardName2 = next.cardName;
            if (next.cardName3 === undefined) next.cardName3 = next.cardName;
        }
        copy[lang] = next;
    });
    return { ...raw, copy };
}

function stampPartnerIds(config) {
    const partners = (config.copy?.EN?.partners || []).map((item, index) => ({
        ...item,
        id: item.id || PARTNER_IDS[index] || `partner-${index + 1}`,
    }));
    return { ...config, copy: { ...config.copy, EN: { ...config.copy.EN, partners } } };
}

function safeParse(raw) {
    if (!raw || typeof raw !== 'string') return {};
    try {
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
        return {};
    }
}

export const isKrasavaLandingEnabled = (community) => {
    const raw = Array.isArray(community?.optionsRaw) ? community.optionsRaw : [];
    return raw.some(
        (opt) => extractOptionType(opt) === ENABLE_KRASAVA_LANDING && extractOptionValue(opt).length > 0
    );
};

export const krasavaText = (config, lang) => {
    const selected = String(lang || 'EN').toUpperCase() === 'RU' ? 'RU' : 'EN';
    return selected === 'RU' ? prefer(config.copy.EN, config.copy.RU) : config.copy.EN;
};

export const getKrasavaLandingConfig = (community, lang) => {
    const raw = Array.isArray(community?.optionsRaw) ? community.optionsRaw : [];
    const option = raw.find((opt) => extractOptionType(opt) === ENABLE_KRASAVA_LANDING);
    const config = stampPartnerIds(merge(DEFAULT_CONFIG, prepareCardNames(safeParse(option?.optionValue ?? option?.value))));
    const landingLogo = typeof config.logo === 'string' ? config.logo.trim() : '';
    const communityLogo = typeof community?.logoUrl === 'string' ? community.logoUrl.trim() : '';
    const selected = String(lang || community?.lang || 'EN').toUpperCase() === 'RU' ? 'RU' : 'EN';
    return { ...config, logo: landingLogo || communityLogo, text: krasavaText(config, selected), lang: selected };
};

export const applyKrasavaThemeVars = (theme = {}) => {
    const root = document.documentElement;
    THEME_VARS.forEach(([key, cssVar]) => {
        const value = theme[key] || DEFAULT_KRASAVA_THEME[key];
        if (value) root.style.setProperty(cssVar, value);
    });
};

export const clearKrasavaThemeVars = () => {
    const root = document.documentElement;
    THEME_VARS.forEach(([, cssVar]) => root.style.removeProperty(cssVar));
};
